import $ from 'jquery';

export const init = () => {

	$(document)
		.on('click', '.js-tabs-filter__link', function(e) {

			var $this = $(this),
				$item = $('.js-transport__inp'),
				$closest = $this.closest('.js-tabs-filter'),
				$link = $closest.find('.js-tabs-filter__link'),
				selector = $this.data('selector'),
				$selectorElements = $('.b-tabs *[data-selector="'+selector+'"]');

			if ($this.is('.b-tabs__link')) {
				e.preventDefault();
			}

			$link.removeClass('is-active');
			$this.addClass('is-active');

			// connects tabs and dropdown menu on responsive
			$selectorElements.addClass('is-active');
			$selectorElements.find('.inp-item__inp').change();

			$item
				.prop('disabled', true)
				.closest('li').hide().addClass('is-hidden');

			$item.filter(selector)
				.prop('disabled', false)
				.closest('li').show().removeClass('is-hidden');

			$item.filter(':disabled:checked')
				.prop('checked', false)
				.closest('li').removeClass('is-checked')
				.find('.f-open__box').slideUp();

			hideFixedBar();
		})
		.on('click', '.b-ajax .js-fixed-show', function() {
			showFixedBar();
		})
		.on('click', '.b-ajax .js-fixed-hide', function() {
			hideFixedBar();
		});

	function showFixedBar() {
		$('.b-ajax__fixed').fadeIn().css('display', 'flex').addClass('is-visible');
	}

	function hideFixedBar() {
		$('.b-ajax__fixed').fadeOut().removeClass('is-visible');
		$('.b-ajax .f-open__inp[type="radio"]').prop('checked', false).closest('.f-open').removeClass('is-checked').find('.f-open__box').slideUp();
	}
};
